import { DashboardLayout } from "@/components/DashboardLayout";
import { StatCard, PlaceholderCard } from "@/components/StatCard";
import { DASH } from "@/constants/testIds";
import { useAuth } from "@/context/AuthContext";

export default function StudentDashboard() {
  const { user } = useAuth();
  return (
    <DashboardLayout title={`Hi ${user?.first_name || "Learner"}, ready to learn?`} breadcrumbs={["Learner", "Overview"]}>
      <div data-testid={DASH.root("student")} className="space-y-8">
        <section className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          <StatCard to="/app/learner/courses" label="My Courses" value="—" icon="BookOpen" tone="navy" testKey="courses" note="View my courses" index={0} />
          <StatCard to="/app/learner/courses" label="Continue Learning" value="—" icon="PlayCircle" tone="green" testKey="continue" note="Resume where you left off" index={1} />
          <StatCard to="/app/learner/exams" label="My Exams" value="—" icon="FileCheck" tone="slate" testKey="exams" note="Attempt & review exams" index={2} />
          <StatCard to="/app/learner/certificates" label="Certificates" value="—" icon="Award" tone="green" testKey="certs" note="Download certificates" index={3} />
        </section>
        <section className="grid gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2 rounded-2xl border border-slate-200 bg-gradient-to-br from-[#101876] to-[#0c135c] p-8 text-white">
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-white/70">Welcome to Steward</div>
            <h3 className="mt-2 text-2xl font-black leading-tight" style={{ fontFamily: "Cabinet Grotesk, sans-serif" }}>
              Your learning starts once your admin assigns your first course.
            </h3>
            <p className="mt-3 text-sm text-white/80">
              We'll notify you here as soon as courses, exams and certifications are ready.
            </p>
          </div>
          <PlaceholderCard title="My Progress" description="Track lessons completed, hours spent and streak weeks." phase="Phase 6" icon="LineChart" tone="green" />
        </section>
      </div>
    </DashboardLayout>
  );
}
